import axios from "axios";
import { getToken, clearAuthData } from "./authService";

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5001/api/v1",
  timeout: 10000,
});

// Request interceptor to add auth token to every request
apiClient.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["X-Authorization"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't logout if it's an events-related 401 (could be the external token)
      const isEventRoute = error.config.url.includes('/celebs/organization-events') || 
                          error.config.url.includes('/celebs/create-event') ||
                          error.config.url.includes('/celebs/upload-media');
      
      if (isEventRoute) {
        return Promise.reject(error);
      }

      // Token expired or invalid for main app
      clearAuthData();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
